import { useState } from "react";
import { Plus, Target, ListChecks, CalendarPlus, Zap } from "lucide-react";
import TaskForm from "./TaskForm";
import MetaCreateModal from "./MetaCreateModal";

/**
 * Bug 19/50 · Barra CTA per Home (non FAB per non oscurare contenuto mobile).
 * 4 pulsanti: Crea Meta / Crea Ciclo / Crea Azione / Crea Evento.
 *
 * Ogni CTA apre modal dedicato con `type` preselezionato dove applicabile.
 * Chiusura + toast gestita dai singoli modal (Bug 2 preservato).
 *
 * Props:
 *   - onCreated(): callback dopo qualunque creazione per refresh Home.
 */
export default function HomeCtaBar({ onCreated }) {
  const [metaOpen, setMetaOpen] = useState(false);
  const [cicloOpen, setCicloOpen] = useState(false);
  const [azioneOpen, setAzioneOpen] = useState(false);
  const [eventoOpen, setEventoOpen] = useState(false);

  const handled = () => { onCreated?.(); };

  return (
    <>
      <section className="pxos-card p-4" data-testid="home-cta-bar">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <div className="text-[11px] uppercase tracking-widest opacity-70">Nuove voci</div>
            <h2 className="font-display text-base font-semibold">Cosa vuoi aggiungere?</h2>
          </div>
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => setMetaOpen(true)}
                    className="pxos-btn-secondary text-sm inline-flex items-center gap-1.5"
                    data-testid="home-cta-meta">
              <Target size={14}/> Meta
            </button>
            <button type="button" onClick={() => setCicloOpen(true)}
                    className="pxos-btn-primary text-sm inline-flex items-center gap-1.5"
                    data-testid="home-cta-ciclo">
              <ListChecks size={14}/> Ciclo
            </button>
            <button type="button" onClick={() => setAzioneOpen(true)}
                    className="pxos-btn-secondary text-sm inline-flex items-center gap-1.5"
                    data-testid="home-cta-azione">
              <Zap size={14}/> Azione
            </button>
            <button type="button" onClick={() => setEventoOpen(true)}
                    className="pxos-btn-secondary text-sm inline-flex items-center gap-1.5"
                    data-testid="home-cta-evento">
              <CalendarPlus size={14}/> Evento
            </button>
          </div>
        </div>
      </section>

      <MetaCreateModal
        open={metaOpen}
        onClose={() => setMetaOpen(false)}
        onCreated={() => { handled(); }}
      />
      <TaskForm
        open={cicloOpen} defaultType="task"
        onClose={() => setCicloOpen(false)}
        onSaved={() => { setCicloOpen(false); handled(); }}
      />
      <TaskForm
        open={azioneOpen} defaultType="task"
        onClose={() => setAzioneOpen(false)}
        onSaved={() => { setAzioneOpen(false); handled(); }}
      />
      <TaskForm
        open={eventoOpen} defaultType="appointment"
        onClose={() => setEventoOpen(false)}
        onSaved={() => { setEventoOpen(false); handled(); }}
      />
    </>
  );
}
